import { useCurrentUser } from './useCurrentUser'

export const useRole = () => {
  const { data: currentUser } = useCurrentUser()

  if (!currentUser) return null

  return currentUser.type
}
